import React, { useEffect, useMemo, useRef, useState } from 'react'
import Popup from "reactjs-popup";
import { ref, deleteObject } from "firebase/storage";
import { storageRef } from "../UppyModal/FirebasePluginUppy"
import CONSTANTS from "../../utils/constants"
import "reactjs-popup/dist/index.css";
import UppyModal from '../UppyModal/UppyModal';
import { MdVerified, MdErrorOutline } from 'react-icons/md'
import { TiDeleteOutline } from 'react-icons/ti'
import { useBeforeunload } from 'react-beforeunload';
import { useImmer } from 'use-immer';
import "./fileUploadPopup.css"
import { toast } from 'react-toastify';
const toastOptions = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};
const { FILE_CATEGORY, EXAM } = CONSTANTS();
const ShowStatus = ({ status, onDelete }) => {
    if (status === "uploading") {
        return (
            <div class="spinner-border text-light ms-2" style={{ borderRadius: "50%" }} role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        )
    }
    else if (status === "uploaded") {
        return (
            <MdVerified color='green' className='ms-2 mt-auto mb-auto' size={"2rem"} />
        )
    }
    else if (status === "upload") {
        return (
            <TiDeleteOutline color='red' className='ms-2 mt-auto mb-auto' size={"2rem"} onClick={onDelete} />
        )
    }
    else if (status === "error") {
        return (
            <MdErrorOutline color='red' className='ms-2 mt-auto mb-auto' size={"2rem"} />
        )
    }
}
const FileInput = ({ status, name, id, onDelete, setFileName }) => {
    return (
        <div class="input-group mb-3">
            <input type="text" value={name} onChange={(e) => setFileName(e.target.value)} disabled={(status === "uploaded" || status === "uploading")} class="form-control" placeholder="Enter file name" aria-label="File upload file name" aria-describedby="UppyfileUpload" />
            <ShowStatus status={status} onDelete={onDelete} />
        </div>
    )
}
// {
//     id: "none",
//     name: "none",
//     mimeType: "none",
//     url: "none"                
//     status
// }
const deleteUnUploadedFiles = async (files) => {
    files.forEach(async (file) => {
        if (file.status && (file.status === "upload")) {
            await deleteObject(ref(storageRef, file.id));
        }
        else if (!file.status) {
            await deleteObject(ref(storageRef, file.id));
        }
    })
}
const FacultyUploadModal = ({ subject, sem }) => {
    const popupRef = useRef();
    const [show, setShow] = useState(false);
    const [uploadModal, setUploadModal] = useState(false);
    // const [category,setCategory]=useState("study-materials");
    // const [exam,setExam]=useState("semester");

    const [fileDetails, setFileDetails] = useImmer({
        category: FILE_CATEGORY.STUDY_MATERIALS,
        exam: EXAM.SEM,
        files: []
    })
    const onFileRemove = async (fileId) => {
        await deleteUnUploadedFiles([{ id: fileId }]);
        setFileDetails(draft => {
            draft.files = draft.files.filter(f => f.id !== fileId);
        })
    }
    const addFiles = () => {
        setShow(true);
    }
    const course = useMemo(() => {
        const latestBatch = Math.max(...subject.batches);
        console.log('====================================');
        console.log("Batches",subject.batches);
        console.log('====================================');
        // sections '*' will assign to all the sections
        return ({
            degree: subject.degree,
            branch: subject.branch,
            sections: "*",
            subject: subject._id,
            sem: sem,
            year: subject.year,
            batch: latestBatch
        })
    }, [subject, sem]);
    // const defaultFieldValues = {
    //     degree: "none",
    //     branch: "none",
    //     section: "none",
    //     subject: "none",
    //     sem: "none",
    //     year: "none",
    //     category: FILE_CATEGORY.STUDY_MATERIALS,
    //     exam: EXAM.SEM,
    //     batch: "none",
    //     id: "none",
    //     name: "none",
    //     mimeType: "none",
    //     url: "none"
    // };
    const onClose = async () => {
        setShow(false);
    }
    const uploadFiles = () => {
        const courseObj = {
            category: fileDetails.category,
            exam: fileDetails.exam,
            ...course
        }
        const total = fileDetails.files.length;
        fileDetails.files.forEach(async (file, index) => {
            setFileDetails(draft => {
                let foundFile = draft.files.find(f => f.id === file.id);
                if (foundFile) {
                    foundFile.status = "uploading";
                    foundFile.status = "uploading";
                }
            });
            const r = await fetch("/api/file/job", {
                method: "POST",
                headers: {
                    'Content-Type': "application/json"
                },
                body: JSON.stringify({
                    ...courseObj,
                    ...file,
                    name: file.name + "." + file.ext
                })
            });
            if (r.status !== 200) {
                const res = await r.json();
                setFileDetails(draft => {
                    draft.files.find(f => f.id === file.id).status = "error";
                });
                console.log(res);
                return;
            }
            setFileDetails(draft => {
                draft.files.find(f => f.id === file.id).status = "uploaded";
            });
            if (index === total - 1) {
                setTimeout(() => {
                    popupRef.current.close();
                    toast.success("Uploaded successfully, soon the file will be visible in dashboard", toastOptions);
                }, 300)
            }
            return;

        })
    }

    const onSuccess = (result) => {
        if (result.failed.length > 1) {
            alert("Failed to upload");
            console.log(result);
            return;
        }
        // setValue("url", result.successful[0].downloadUrl);
        // setValue("name", result.successful[0].name);
        // setValue("mimeType", result.successful[0].type);
        // setValue("id", result.successful[0].refId);
        setFileDetails(draft => {
            result.successful.forEach(res => {
                let name = res.name.split('.');
                let ext = name.pop();
                name = name.join(".");
                draft.files.push({
                    id: res.refId,
                    name: name,
                    ext: ext,
                    status: "upload",
                    url: res.downloadUrl,
                    mimeType: res.type
                })
            });
        })
    }
    const isSubjectLoaded = subject._id ? true : false;
    useEffect(() => {
        return async () => {
            setFileDetails(draft => {
                draft.files = [];
            })
        }
    }, [uploadModal])
    useBeforeunload((event) => {
        if (fileDetails.files.some(file => file.status === "upload")) {
            event.preventDefault();
        }
    })
    if (!isSubjectLoaded) {
        return (<button className="eoa" disabled={!isSubjectLoaded}>
            No subject
        </button>)
    }

    return (
        <>
            <UppyModal show={show} onClose={onClose} onSuccess={onSuccess} />
            <Popup
                className="fileUploadPopup"
                closeOnDocumentClick={false}
                ref={popupRef}
                onOpen={() => setUploadModal(true)}
                onClose={() => setUploadModal(false)}
                contentStyle={{ height: "-webkit-fill-available" }}
                fullScreen={true}
                trigger={
                    <button className="eoa" disabled={!isSubjectLoaded}>Upload</button>
                }
                modal
            >
                {(close) => (
                    <div className="container-fluid" id="facUploadPopupWrapper" style={{ position: "relative", height: "100vh" }}>
                        <div className="d-flex" style={{ justifyContent: "space-between" }}>
                            <button className="closeColorBtn" onClick={async (e) => {
                                await deleteUnUploadedFiles(fileDetails.files);
                                close(e);
                            }}>
                                &times;
                            </button>
                            <h5 className="p-1" style={{ color: "white" }}> Upload files </h5>
                        </div>
                        <div className="content col-md-6 ms-auto me-auto" style={{ position: "relative", maxHeight: "80vh", minHeight: "50vh", overflowY: "auto", padding: "0", margin: "0" }}>
                            <label style={{ color: "white", fontSize: '1.2rem', paddingBottom: "5px" }}>Select category</label>
                            <select class="form-select" aria-label="Default select example" value={fileDetails.category} onChange={(e) => setFileDetails(draft => void (draft.category = e.target.value))}>
                                <option value="study_materials">Study materials</option>
                                <option value="qns">Question papers</option>
                                <option value="assignments">Assignment Questions</option>
                            </select>
                            <label style={{ color: "white", fontSize: '1.2rem', paddingBottom: "5px" }}>Select exam</label>
                            <select class="form-select" aria-label="Default select example" value={fileDetails.exam} onChange={(e) => setFileDetails(draft => void (draft.exam = e.target.value))}>
                                <option value="mid1">Mid 1</option>
                                <option value="mid2">Mid 2</option>
                                <option value="semester">Semester</option>
                            </select>
                            <div class="form-group">
                                {/* <label for="formFile" class="form-label text-primary">
                                    Add file
                                </label> */}
                                <div className='container mt-3' style={{ maxHeight: "32vh", overflowY: "scroll", position: "relative" }}>
                                    {fileDetails.files.map(file => {
                                        return (
                                            <FileInput key={file.id} name={file.name} setFileName={(text) => setFileDetails(draft => {
                                                draft.files.find(f => f.id === file.id).name = text;
                                            })} status={file.status} onDelete={() => onFileRemove(file.id)} />
                                        )
                                    })}
                                </div>
                                <sub>Format : Unit-I (can add multiple units at once)</sub>
                            </div>
                        </div>
                        <div className="fileUploadPopupFooter bg-light" >
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                                <button className="addfilesBtn me-1" onClick={addFiles}>Add files</button>
                                <button className="eoa ms-1" onClick={uploadFiles}>Upload</button>
                            </div>
                        </div>
                    </div>
                )}
            </Popup>
        </>
    )
}

export default FacultyUploadModal